import { useBreakpoints } from '@/scopes/common/components/utils/breakpoints'
import { Bar } from '@/scopes/search/components/QuickSearchBarLegacy/QuickSearchContentLegacy'
import { tk } from '@sunwebgroup/ui-components'

import { type PropsWithChildren, useRef } from 'react'

import { useIntersection } from 'react-use'
import { styled } from 'styled-components'

export * as Item from './Item'

const Container = styled.div`
  --quicksearch-bar-height: 72px;
  box-sizing: content-box;
  height: var(--quicksearch-bar-height);
  padding-bottom: ${tk('spacing_md')};
  @media ${tk('mq_desktop_sm')} {
    --quicksearch-bar-height: 80px;
  }
  @media ${tk('mq_desktop_md')} {
    padding-bottom: ${tk('spacing_3xl')};
  }
`

const Sentinel = styled.div`
  background: transparent;
  height: 1px;
  margin-bottom: -1px;
  width: 100%;
`

export function QuickSearchBarLegacy({
  sticky = true,
  children,
}: PropsWithChildren<{
  sticky?: boolean
  disabled?: boolean
}>) {
  const { isDesktopSm } = useBreakpoints()

  const sentinelRef = useRef<HTMLDivElement>(null)
  const observer = useIntersection(sentinelRef, {
    root: null, // Defaults to the browser viewport
    rootMargin: '0px',
    threshold: 1,
  })

  return (
    <Container>
      <Sentinel ref={sentinelRef} />
      <Bar $isDesktop={isDesktopSm} $isSticky={sticky && observer ? !observer.isIntersecting : false}>
        {children}
      </Bar>
    </Container>
  )
}
